import { render } from "./person-access-update.vue?vue&type=template&id=6da9e940"
import script from "./person-access-update.vue?vue&type=script&lang=js"
export * from "./person-access-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__